import React from 'react';
import SEO from '../components/SEO';
import PreFooterCallout from '../components/PreFooterCallout';
import { imageUrl, srcSet } from '../lib/images';

export default function OmMig() {
  return (
    <div>
      <SEO
        title="Om mig - Advokatfirmaet Kopp"
        description="Titti Kopp, Advokat, Ph.d., Partner +25 års erfaring med miljøretlig rådgivning inden for størstedelen af miljørettens fagområder. +10 års erfaring med bygherrerådgivning og projektledelse relateret til nogle af Danmarks største og mest komplekse infrastruktur-projekter, som fx Femern-projektet, Kattegat-projektet, Als-Fyn-projektet."
        ogImage={imageUrl('titti-05-til-om-mig-naar-man-er-gaaet-ind-under-fanen.webp')}
      />

      <section className="w-full bg-white py-16 lg:py-24 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-stretch">
          {/* Left Column: Heading + Paragraphs + Bullet points */}
          <div className="lg:col-span-7 space-y-6 flex flex-col justify-between">
            <div className="space-y-6">
              <h1 className="text-3xl lg:text-4xl font-bold text-[#34657f]">
                Titti Kopp, Advokat, Ph.d., Partner
              </h1>

              <div className="space-y-4 text-xs sm:text-sm text-slate-600 leading-relaxed">
                <p>
                  +25 års erfaring med miljøretlig rådgivning inden for størstedelen af miljørettens fagområder.
                </p>
                <p>
                  +10 års erfaring med bygherrerådgivning og projektledelse relateret til nogle af Danmarks største og mest komplekse infrastruktur-projekter, som fx Femern-projektet, Kattegat-projektet, Als-Fyn-projektet.
                </p>
              </div>

              <ul className="space-y-4 pt-2 text-xs sm:text-sm text-slate-600 leading-relaxed">
                <li className="flex items-start space-x-3">
                  <span className="w-2 h-2 rounded-full bg-[#34657f] mt-2 shrink-0" />
                  <span>
                    Min rådgivning fokuserer på at sikre optimal processtyring under hensyntagen til de myndighedskrav, som projektet vil blive mødt med. Det giver bygherren mulighed for proaktivt at navigere sin projektudvikling og gennemførelse af projektet, så kravene minimeres eller undgås og fremdrift og økonomi sikres ud fra et bevidst valg af risikoprofil.
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-2 h-2 rounded-full bg-[#34657f] mt-2 shrink-0" />
                  <span>
                    Med afsæt i lovgivningskravene har jeg stor erfaring med at anvise vejen for et effektivt samarbejde mellem fagdisciplinerne indbyrdes som led i projektudviklingen.
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-2 h-2 rounded-full bg-[#34657f] mt-2 shrink-0" />
                  <span>
                    Jeg forestår varetagelsen af dialog med myndigheder omkring krav til projektet og håndterer eventuelle klagesager.
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-2 h-2 rounded-full bg-[#34657f] mt-2 shrink-0" />
                  <span>
                    Min rådgivning har fokus på samtidig inddragelse af bæredygtighedsreguleringen, så der træffes valg, der inkluderer en samtidig stillingtagen til det ønskede ambitionsniveau.
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-2 h-2 rounded-full bg-[#34657f] mt-2 shrink-0" />
                  <span>
                    I forhold til myndigheder består min rådgivning typisk i rådgivning om juridiske krav til sagsbehandlingen samt bistand til håndtering af klagesager mv.
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Column: First Image */}
          <div className="lg:col-span-5 relative min-h-[360px] lg:min-h-0 h-full">
            <div className="w-full h-full min-h-[360px] lg:min-h-0 relative lg:absolute lg:inset-0">
              <img
                src={imageUrl('titti-05-til-om-mig-naar-man-er-gaaet-ind-under-fanen.webp', 'width=900,height=600,fit=cover,quality=85,format=auto')}
                srcSet={srcSet('titti-05-til-om-mig-naar-man-er-gaaet-ind-under-fanen.webp')}
                sizes="(max-width: 1024px) 100vw, 40vw"
                alt="Titti Kopp, Advokat, Ph.d."
                className="w-full h-full object-cover object-[50%_12%]"
                style={{ objectPosition: '50% 12%' }}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Pre-Footer Callout */}
      <PreFooterCallout />
    </div>
  );
}
